import React, { useEffect, useState } from "react";
import { Navigate, NavLink, Outlet, Route, Routes } from "react-router-dom";
import { teamDetailsModule } from "../lib/components/TeamDetailsModule";

import api from "../utils/api";
import Loader from "../lib/components/Loader";

const TeamDetails = ({ managerName }) => {
    const [teamDetails, updateTeamDetails] = useState({});
    const [loading, updateLoading] = useState(false);

    useEffect(() => {
        updateLoading(true);
        api.get(`/api/v1/managers`).then(({ data }) => {
            updateTeamDetails(data[managerName]);
        }).catch(err => {
            console.error('Error retrieving team details', err);
        }).finally(() => {
            updateLoading(false);
        });
    }, []);

    if (loading) {
        return <Loader/>
    }

    if (!teamDetails) {
        return <></>
    }

    return (
        <div>
            {teamDetailsModule(teamDetails)}
        </div>
    )
}

const handleContractUpdate = (id, contract) => {
    api.post('/api/v2/players/contract/update', {id: id, contract: Number(contract)}).then(() => {
        console.log(`Updated ${id}, ${contract}`);
    }).catch(res => {
        console.error(res);
    });
}

const MyTeam = ({ userData, playerData, outgoingPicks }) => {
    if (!userData.permissions) {
        return <Navigate to='/login'/>
    }

    if (userData.permissions === 'admin') {
        return <Navigate to='/admin'/>
    }
    
    const managerName = userData.permissions;

    if (!playerData || !outgoingPicks) {
        return <Loader />;
    }

    return (
        <div>
            <h2>My Team</h2>
            <div id="team-details">
                <TeamDetails managerName={managerName}/>
            </div>
            <div id="my-team-nav-bar">
                <NavLink
                    to={`/myTeam/players`}
                    className={({ isActive }) =>
                        `list-group-item list-group-item-action ${isActive ? "active" : ""}`
                    }
                    style={{ padding: '0.5rem' }}
                >
                    Players
                </NavLink>
                <NavLink
                    to={`/myTeam/pendingTrades`}
                    className={({ isActive }) =>
                        `list-group-item list-group-item-action ${isActive ? "active" : ""}`
                    }
                    style={{ padding: '0.5rem' }}
                >
                    Pending Trades
                </NavLink>
                <NavLink
                    to={`/myTeam/draftPicks`}
                    className={({ isActive }) =>
                        `list-group-item list-group-item-action ${isActive ? "active" : ""}`
                    }
                    style={{ padding: '0.5rem' }}
                >
                    Draft Picks
                </NavLink>
            </div>
            <Outlet context={{ managerName }}/>
        </div>
    );
}

export default MyTeam;